import { ActionType } from 'typesafe-actions'
import * as actions from '../actions/sales-groups'
import { wdqlMergeOne, wdqlMergeSet } from '../util/remote/wdql'
import { SalesGroupEntity } from '../types/entity-types'

const SalesGroupReducer = (
  state: SalesGroupEntity[] = [],
  action: ActionType<typeof actions>
) => {
  switch (action.type) {
    case actions.WDQL_MERGE_SALES_GROUP:
      return wdqlMergeOne(state, action.payload)
    case actions.WDQL_MERGE_SALES_GROUPS:
      return wdqlMergeSet(state, action.payload)
    default:
      return state
  }
}

export default SalesGroupReducer
